import React, {useState, useEffect, useCallback} from 'react';
import {Link} from 'react-router-dom';
import {InputSwitch} from "../checkbox/InputSwitch";
import {useDispatch, useSelector} from "react-redux";
import {
  UPDATE_CHAT_SETTINGS,
  roleAdmin,
  roleTechnicalSpecialist,
  formatErrors,
  UPDATE_CHAT_ACTIVE,
  userStatusActive,
  UPDATE_USER_PROFILE
} from "../../constants";
import {InputRadio} from "../radio/InputRadio";
import {
  changeDayOffAction,
  getProfileAction
} from "../../actions/profileAction";
import {toast} from "react-toastify";

//export function MenuDropdown(props) {
export function MenuDropdown({filter, props, handleChange}) {
  const settings = useSelector(state => state.chat.settings);
  const dispatch = useDispatch();
  const notificationsChange = (checked) => {
    dispatch({type: UPDATE_CHAT_SETTINGS, settings: {notifications_disabled: !checked}})
  };
  const user = useSelector(state => state.user.profile);
  const [dayOff, setDayOff] = useState(user.status === userStatusActive ? false:true);
  const [loading, setLoading] = useState(false);

  const getProfileInfo = useCallback(() => {
    dispatch(getProfileAction()).then((data) => {
        setDayOff(data.status === userStatusActive ? false:true)
        dispatch({type: UPDATE_USER_PROFILE, profile: {enable_ai: data.enable_ai} });
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
    
  }, [dayOff, dispatch]);

  const sendByChange = (value) => {
    dispatch({type: UPDATE_CHAT_SETTINGS, settings: {send_by: value}})
  };

  const handleChangeDayOff = (name, checked) => {
    if (loading) {
      return false;
    }
      
    setDayOff(checked)
    
    setLoading(true);
    
    dispatch(changeDayOffAction(checked)).then(() => {
        handleChange()
        
        if(checked) {
            localStorage.removeItem('dc_currentChat');
              dispatch({type: UPDATE_CHAT_ACTIVE});
        }
        
        //setLoading(false);
        
        if(checked){
            toast.success('Идет процесс распределения клиентов по временным кураторам', {position: toast.POSITION.BOTTOM_RIGHT});
        }
        
        //window.location.reload();
    }).catch(err => {
        //setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    if (loading) {
      return false;
    }
      
    getProfileInfo();
  }, [getProfileInfo]);

  return <div className="sidebar-chat__hamburger">
    <button type="button" className="hamburger">
      Меню
      <span className="hamburger__inner"></span>
      <span className="hamburger__inner"></span>
      <span className="hamburger__inner"></span>
    </button>
    <ul className="dropdown dropdown--main">
      {user && user.modules && user.modules['Chat'] && <li className="dropdown__item">
        <Link to={'/'} className="dropdown__link dropdown__link--chat">Сообщения</Link>
      </li>}
      {user && user.modules && user.modules['Clients'] && <li className="dropdown__item">
        <Link to={'/clients'} className="dropdown__link dropdown__link--users">Пользователи</Link>
      </li>}
      {user && user.modules && user.modules['GetcourseData'] && <li className="dropdown__item">
        <Link to={'/getcourse_data'} className="dropdown__link dropdown__link--users">Пользователи getcourse</Link>
      </li>}

      {user && user.modules && user.modules['ShiftControl'] && <li className="dropdown__item">
        <Link to={'/shift_control'} className="dropdown__link dropdown__link--reports">Контроль смен</Link>
      </li>}
      {user && user.modules && user.modules['ResponseTime'] && <li className="dropdown__item">
        <Link to={'/response_time'} className="dropdown__link dropdown__link--reports">Время ответов</Link>
      </li>}
      {user && user.modules && user.modules['Flows'] && <li className="dropdown__item">
        <Link to={'/triggers'} className="dropdown__link dropdown__link--reports">Процессы</Link>
      </li>}
      {user && user.modules && user.modules['Mailing'] &&   <li className="dropdown__item">
        <Link to={'/mailings'} className="dropdown__link dropdown__link--mailings">Рассылки</Link>
      </li>}
      <li className="dropdown__item">
        <Link to={'/profile'} className="dropdown__link dropdown__link--profile">Профиль</Link>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <InputSwitch className="dropdown__link--day-off" title="Выходной день" name="day_off" checked={dayOff} onChange={handleChangeDayOff} disabled={loading}/>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <InputSwitch className="dropdown__link--notify" title="Уведомления" name="notifications_disabled" checked={settings.notifications_disabled !== true} onChange={(name, checked) => notificationsChange(checked)}/>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <InputRadio text="Отправлять по Enter" name="send_by" value={1} checked={settings.send_by === 1} onChange={(name, value) => sendByChange(value)}/>
        <InputRadio text="Отправлять по Ctrl+Enter" name="send_by" value={0} checked={settings.send_by !== 1} onChange={(name, value) => sendByChange(value)}/>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <Link to={'/logout'} className="dropdown__link dropdown__link--exit">Выйти</Link>
      </li>
    </ul>
  </div>;
}
